import { render } from "./Texto.vue?vue&type=template&id=35487802"
import script from "./Texto.vue?vue&type=script&lang=js"
export * from "./Texto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__